import { render, staticRenderFns } from "../base/BaseStandardPage.html?vue&type=template&id=08a93fe1&external"
import script from "./PtOverviewPage.vue?vue&type=script&lang=ts"
export * from "./PtOverviewPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports